import { forwardRef, useEffect, useState } from 'react';

import styled from '@emotion/styled';
import Input from '@mui/material/Input';
import { IMaskInput } from 'react-imask';
import { useTheme } from "@mui/material";

// import TextField from '@mui/material/TextField';

const TextInputWrapperStyled = styled.div`
  .css-1x51dt5-MuiInputBase-input-MuiInput-input {
    border-radius: 4px;
    border: #ccc 1px solid;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 16px;
    font-size: 1rem;
    font-weight: 300;
    font-weight: 400;
    height: 26px;
    letter-spacing: 0.00938em;
    line-height: 1.5;
    min-width: 200px;
    padding: 5px 10px;
  }
  .Mui-focused .css-1x51dt5-MuiInputBase-input-MuiInput-input{
    border-color: ${({ main }) => main};
    box-shadow: 0px 0px 0px 3px rgba(${({ mainRGB }) => mainRGB}, 0.25);
  }
`;

const TextMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
  const { onChangeHandler, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="+{7}(000)000-00-00"
      // mask="+# (000) 000-00-00"      
      // definitions={{
      //   // '#': /^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/
      //   // '#': /\d/
      //   // '#': /(?:\+|00)[1-9]/,
      //   // '#': /?:\+|00)(1|7|2[07]|3[0123469]|4[013456789]|5[12345678]|6[0123456]|8[1246]|9[0123458]|(?:2[12345689]|3[578]|42|5[09]|6[789]|8[035789]|9[679])\d/
      // }}
      inputRef={ref}
      onAccept={(value) => {
        // console.log('onAccept', value);
      }}
    // overwrite
    />
  );
});

const PhoneInput = (props) => {
  const { id, name, type, typeName, order, label, required, options, input: { onChange }, meta } = props;
  const { palette } = useTheme();
  const { primary: { contrastText, main, mainRGB } } = palette;
  const [phone, setPhone] = useState('');
  const [formats, setFormats] = useState({
    textmask: '+7 (000) 000-0000',
    numberformat: '1320',
  });

  // when component is already mount
  useEffect(() => {
    let defaultValue = "";
    // Compute default value, choose first from options(in normal case there should be single option/value)
    if (options) {
      for (let option of options) {
        if (option.default) {
          defaultValue = option.value;
          // 'cos in text input type only one text is set
          // perhaps in future features will be needed to set joined text options/values into single value 
          break;
        }
      }

      // Set default value
      if (defaultValue) {
        setPhone(defaultValue);

        onChange({
          id,
          typeName,
          order,
          result: defaultValue
        });
      }
    }
  }, []);

  const changeHandler = (event) => {
    let value = event?.target?.value;
    setPhone(value);

    if (!value) {
      return onChange(null);
    }

    value = value.replace(/\D/g, '');

    return onChange({
      id,
      typeName,
      order,
      result: value
    });
  };

  // const mask = '+7 (000) 000-0000';

  // const changeHandlerWithMask = (event) => {
  //   const { value } = event.target;

  //   const maskedValue = '';

  //   if (phone.length > value.length) {
  //     setPhone(value);
  //     return;
  //   }

  //   if (value.length > 2 && value.length <= 4) {
  //     setPhone(mask.slice(0, 4));
  //     return;
  //   }
  //   if (value.length <= 2) {
  //     setPhone(mask.slice(0, value.length));
  //     return;
  //   }
  //   // const v = mask[value.length];

  //   // if (v != '0') {
  //   //   setPhone(mask.slice(phone.length, value.length));
  //   //   return;
  //   // }

  //   setPhone(value);

  //   // if (!value) {
  //   //   return onChange(null);
  //   // }

  //   // return onChange({
  //   //   id,
  //   //   typeName,
  //   //   order,
  //   //   result: value
  //   // });
  // };

  return (
    <TextInputWrapperStyled main={main} mainRGB={mainRGB}>
      <Input
        value={phone}
        placeholder="+7 (707) 000 00 00"
        onChange={changeHandler}
        name="textmask"
        disableUnderline
        fullWidth
        id="formatted-text-mask-input"
        inputComponent={TextMaskCustom}
      />
    </TextInputWrapperStyled>
  )
}

export default PhoneInput;